import { StateStandard } from '../types';

export const STATE_STANDARDS: StateStandard[] = [
  {
    code: 'ETS_NATIONAL',
    name: 'ETS National Standard (Default)',
    passingScores: {
      '5713': 156, // Core Reading
      '5723': 162, // Core Writing
      '5733': 150, // Core Mathematics
      '5001': 150, // Elementary Multi-Subject
      '5002': 157, // Elem Reading
      '5003': 157, // Elem Math
      '5004': 155, // Elem Social Studies
      '5005': 159, // Elem Science
      '5621': 157, // PLT Early Childhood
      '5622': 160, // PLT Grades K-6
      '5623': 160, // PLT Grades 5-9
      '5624': 160, // PLT Grades 7-12
      '5165': 159, // Secondary Math
      '5038': 167, // English Language Arts
      '5354': 151, // Special Education
      '5435': 152, // General Science
      '5081': 150, // Social Studies
      '5025': 156, // Early Childhood
      '5362': 155, // ESOL
    },
    note: 'Recommended ETS benchmark passing scores.'
  },
  {
    code: 'TX',
    name: 'Texas (TExES / Praxis Crosswalk)',
    passingScores: {
      '5713': 156,
      '5723': 162,
      '5733': 150,
      '5001': 155,
      '5002': 160,
      '5003': 160,
      '5004': 155,
      '5005': 160,
      '5621': 160,
      '5622': 160,
      '5623': 160,
      '5624': 160,
      '5165': 160,
      '5038': 167,
      '5354': 153,
      '5435': 155,
      '5081': 152,
    },
    note: 'Texas SBEC standard passing thresholds.'
  },
  {
    code: 'CA',
    name: 'California (Commission on Teacher Credentialing)',
    passingScores: {
      '5713': 160,
      '5723': 164,
      '5733': 156,
      '5001': 160,
      '5002': 162,
      '5003': 162,
      '5004': 158,
      '5005': 162,
      '5621': 160,
      '5622': 162,
      '5623': 162,
      '5624': 162,
      '5165': 162,
      '5038': 170,
      '5354': 155,
      'FoRT-890': 240,
    },
    note: 'CTC California standard alignment.'
  },
  {
    code: 'PA',
    name: 'Pennsylvania (PDE)',
    passingScores: {
      '5713': 156,
      '5723': 162,
      '5733': 142, // PA qualifying score scale
      '5001': 148,
      '5002': 157,
      '5003': 157,
      '5004': 155,
      '5005': 159,
      '5622': 160,
      '5624': 160,
      '5165': 159,
      '5038': 167,
      '5354': 151,
    },
    note: 'Pennsylvania PDE Qualifying Scores with sliding scale option.'
  },
  {
    code: 'FL',
    name: 'Florida (FTCE / Praxis Equivalent)',
    passingScores: {
      '5713': 156,
      '5723': 162,
      '5733': 150,
      '5001': 150,
      '5622': 160,
      '5624': 160,
      '5165': 160,
      '5038': 167,
    },
    note: 'Florida Department of Education qualifying scores.'
  },
  {
    code: 'VA',
    name: 'Virginia (VDOE)',
    passingScores: {
      '5713': 156,
      '5723': 162,
      '5733': 150,
      '5001': 157,
      '5002': 157,
      '5003': 157,
      '5004': 155,
      '5005': 159,
      '5621': 157,
      '5622': 160,
      '5624': 160,
      '5165': 160,
      '5038': 167,
      '5354': 151,
    },
    note: 'VDOE Licensure requirements.'
  },
  {
    code: 'NY',
    name: 'New York (NYSED / Praxis Alignment)',
    passingScores: {
      '5713': 160,
      '5723': 164,
      '5733': 154,
      '5001': 160,
      '5622': 160,
      '5624': 160,
      '5165': 160,
      '5038': 168,
    },
    note: 'NYSED credentialing score standards.'
  },
  {
    code: 'OH',
    name: 'Ohio (ODE)',
    passingScores: {
      '5713': 156,
      '5723': 162,
      '5733': 150,
      '5001': 150,
      '5622': 160,
      '5624': 160,
      '5165': 159,
    },
    note: 'Ohio Department of Education standards.'
  },
  {
    code: 'GA',
    name: 'Georgia (GaPSC / Praxis Equivalent)',
    passingScores: {
      '5713': 156,
      '5723': 162,
      '5733': 150,
      '5001': 150,
      '5622': 160,
      '5624': 160,
    },
    note: 'Georgia Professional Standards Commission.'
  },
  {
    code: 'NC',
    name: 'North Carolina (NCDPI)',
    passingScores: {
      '5713': 156,
      '5723': 162,
      '5733': 150,
      '5001': 150,
      '5622': 160,
      '5624': 160,
    },
    note: 'NCDPI Licensure examination standards.'
  }
];
